import React from 'react';
import './WelcomeScreen.css';

const WelcomeScreen = ({ onInitialize, isLoading }) => {
  return (
    <div className="welcome-screen">
      <div className="welcome-content">
        <h1>Pose DJ</h1>
        <p>Music Loops for Yoga</p>
        <p className="description">
        Think of it as your personal DJ booth for yoga—where each pose flows into the next on a wave of perfectly looped music. The app lets you mix and match loops in real time, creating a soundtrack that moves with your body and transforms practice into an immersive rhythm.        </p>
        <button 
          className="init-button"
          onClick={onInitialize}
          disabled={isLoading}
        >
          {isLoading ? 'Loading Audio...' : 'Begin'}
        </button>
      </div>
    </div>
  );
};

export default WelcomeScreen;
